import { useParams } from 'react-router-dom';

export default function useSlug() {
  const { slug = null } = useParams();

  return {
    slug
  };
}
